module.exports = __webpack_public_path__ + "static/img/banner1.ee947d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner1.png
// module id = CMrX
// module chunks = 1